module.exports = __webpack_public_path__ + "img/shadow.0dd9430b.svg";